import React from 'react';
import { Route, Redirect } from 'react-router-dom';

/**
 * Visible to the public _only_. Must be logged out.
 * @param Component
 * @param authed
 * @param componentProps
 * @param rest
 * @returns {XML}
 * @constructor
 */
const PublicRoute = function({
  component: Component,
  authed,
  componentProps,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props =>
        authed === false ? (
          <Component {...props} {...componentProps} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/components/auth/PublicRoute.js